import { ComponentProps } from 'react';
import { Link } from 'react-router-dom';

import Icon from '~/components/scales/Icon/Icon';
import { validateDataCy } from '~/components/scales/utils/data-cy';

type Props = {
  className?: string;
  label: string;
  onClick?: () => void;
  to: string;
  'data-cy'?: string;
  isNewInternalTab?: boolean;
};

export default function TextLink(props: Props) {
  const linkProps: ComponentProps<typeof Link> = {
    onClick: props.onClick,
    to: props.to,
  };

  const isExternalLink = props.to.includes('://');
  if (isExternalLink || props.isNewInternalTab) {
    linkProps.target = '_blank';
    linkProps.rel = 'noreferrer';
  }

  validateDataCy(props['data-cy'], 'text-link');

  // if the provided className includes a class that starts with 'type-', we don't want to use the default
  const textTypeClass =
    props.className && props.className.split(' ').some((cls) => /^type-/.test(cls))
      ? ''
      : 'type-body1';

  return (
    <Link
      className={[
        'group inline-flex items-center gap-1 text-type-link outline-none',
        textTypeClass,
        props.className ?? '',
      ].join(' ')}
      {...linkProps}
      data-cy={props['data-cy']}
    >
      <span className="group-hover:underline group-focus-visible:underline group-focus-visible:decoration-selection-focus-fill group-focus-visible:decoration-2">
        {props.label}
      </span>
      {isExternalLink && <Icon name="open_in_new" size="sm" />}
    </Link>
  );
}
